import { generateColor } from 'lib/helpers/generateColor';
import {
  AmlAdditionalRiskCategoryTags,
  FinancialTPCategoryTags,
  AdditionalCategoryTags,
  FinancialCategoryTags,
  GameStyleCategoryTags,
  AssessmentsTags,
  PlayerStatuses,
  OppositeType,
  ProductsType,
  Type, crmtGS
} from './tags';

export const generateNameColor = (tagName) => {
  const { name, color } = {
    ...GameStyleCategoryTags,
    ...FinancialCategoryTags,
    ...AdditionalCategoryTags,
    ...PlayerStatuses,
    ...AmlAdditionalRiskCategoryTags,
    ...AssessmentsTags,
    ...OppositeType,
    ...ProductsType,
    ...Type,
    ...crmtGS,
    ...FinancialTPCategoryTags }[tagName] || {};
  if (name && color) return { name, color };

  return { name: tagName, color: generateColor(tagName) };
};
